import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/news/Layout";
import { AdsProvider } from "@/components/news/Ads";
import { AuthProvider, useAuth } from "@/hooks/useAuth";
import Home from "@/pages/Home";
import ArticlePage from "@/pages/ArticlePage";
import CategoryPage from "@/pages/CategoryPage";
import SearchPage from "@/pages/SearchPage";
import SavedPage from "@/pages/SavedPage";
import SourcesPage from "@/pages/SourcesPage";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import PostEditor from "@/pages/admin/PostEditor";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="p-10 text-center text-muted-foreground">A verificar sessão…</div>;
  return user ? children : <Navigate to="/admin/login" replace />;
}

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <AdsProvider>
          <BrowserRouter>
            <Routes>
              <Route element={<Layout />}>
                <Route path="/" element={<Home />} />
                <Route path="/noticia/:id" element={<ArticlePage />} />
                <Route path="/noticia/:id/:slug" element={<ArticlePage />} />
                <Route path="/categoria/:slug" element={<CategoryPage />} />
                <Route path="/fonte/:slug" element={<CategoryPage />} />
                <Route path="/pesquisa" element={<SearchPage />} />
                <Route path="/guardados" element={<SavedPage />} />
                <Route path="/fontes" element={<SourcesPage />} />
              </Route>
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<Protected><AdminDashboard /></Protected>} />
              <Route path="/admin/nova" element={<Protected><PostEditor /></Protected>} />
              <Route path="/admin/editar/:id" element={<Protected><PostEditor /></Protected>} />
            </Routes>
            <Toaster position="top-center" richColors />
          </BrowserRouter>
        </AdsProvider>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
